/*
 * Option buttons that know what is in stock (Jenny 2026-09-29).
 *
 * THE PROBLEM
 * With two kinds of option (Metal and Type, Color and Size), a value is
 * rarely sold out on its own: Gold is sold out with "Original" but in stock
 * with "Extra leaf add-on". The old list only marked a value sold out when
 * EVERY combination with it was, so shoppers found out one combination at
 * a time and gave up.
 *
 * WHAT THIS DOES
 *   1. Each button is judged against what is picked in the other rows. With
 *      Gold picked, "Original" shows Sold Out. Pick Silver and it flips.
 *   2. A marked button can still be picked. When it is, the other rows move
 *      to the in-stock combination that changes the fewest of them, and one
 *      line says what moved, so she is never left on a sold-out combination
 *      without being told why there was a better one.
 *   3. When a value is sold out with everything, nothing moves: the price
 *      row and the Add to cart button say Sold out.
 *
 * It runs in the CAPTURE phase on <variant-radios>, so the other rows are
 * already moved when Dawn's own change handler (global.js, bubble phase)
 * reads the checked buttons and updates the price, photo, URL and cart form.
 * The markup's first paint is worked out in main-product.liquid, so nothing
 * flashes while this loads.
 */
(function () {
  function variantsOf(root) {
    if (!root.fjVariants) {
      var json = root.querySelector('script[type="application/json"]');
      root.fjVariants = json ? JSON.parse(json.textContent) : [];
    }
    return root.fjVariants;
  }

  function groups(root) {
    return [].slice.call(root.querySelectorAll('fieldset.fj-options__group'));
  }

  function picked(root) {
    return groups(root).map(function (g) {
      var on = g.querySelector('input[type="radio"]:checked');
      return on ? on.value : null;
    });
  }

  function inStock(variants, options) {
    return variants.some(function (v) {
      return v.available && v.options.every(function (o, i) { return o === options[i]; });
    });
  }

  /* The in-stock variant with `value` at `index` that keeps the most of the
     current picks. Among those, the one whose other values sit CLOSEST in
     their rows to what was picked: XX-Large in White steps down to Large,
     not all the way to X-Small. */
  function nearestInStock(variants, current, index, value, orders) {
    var best = null;
    var bestKept = -1;
    var bestDistance = Infinity;
    variants.forEach(function (v) {
      if (!v.available || v.options[index] !== value) return;
      var kept = 0;
      var distance = 0;
      v.options.forEach(function (o, i) {
        if (i === index) return;
        if (o === current[i]) kept++;
        else distance += Math.abs(orders[i].indexOf(o) - orders[i].indexOf(current[i]));
      });
      if (kept > bestKept || (kept === bestKept && distance < bestDistance)) {
        best = v;
        bestKept = kept;
        bestDistance = distance;
      }
    });
    return best;
  }

  function refresh(root) {
    var variants = variantsOf(root);
    var current = picked(root);
    groups(root).forEach(function (g, index) {
      var chosen = g.querySelector('.fj-options__chosen');
      if (chosen) chosen.textContent = current[index] || '';
      g.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var trial = current.slice();
        trial[index] = input.value;
        var ok = inStock(variants, trial);
        var label = root.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        label.classList.toggle('is-sold-out', !ok);
        var tag = label.querySelector('.fj-option__tag');
        if (tag) tag.hidden = ok;
      });
    });
  }

  function say(root, text) {
    var note = root.querySelector('.fj-options__note');
    if (!note) return;
    note.textContent = text || '';
    note.hidden = !text;
  }

  function onChange(event) {
    var root = event.currentTarget;
    var input = event.target;
    if (!input || input.type !== 'radio') return;

    var all = groups(root);
    var index = all.indexOf(input.closest('fieldset.fj-options__group'));
    var variants = variantsOf(root);
    var current = picked(root);
    var message = '';

    if (index > -1 && !inStock(variants, current)) {
      var orders = all.map(function (g) {
        return [].slice.call(g.querySelectorAll('input[type="radio"]')).map(function (r) { return r.value; });
      });
      var target = nearestInStock(variants, current, index, input.value, orders);
      if (target) {
        var moved = [];
        var soldOut = current.join(' + ');
        target.options.forEach(function (value, i) {
          if (i === index || value === current[i]) return;
          var other = [].slice.call(all[i].querySelectorAll('input[type="radio"]')).filter(function (r) {
            return r.value === value;
          })[0];
          if (other) {
            other.checked = true;
            moved.push(value);
          }
        });
        if (moved.length) {
          /* "White + XX-Large is sold out, so we switched you to Large."
             Names the sold-out combination and what it moved to. It never
             says "only", because White may come in four other sizes. */
          message = soldOut + ' is sold out, so we switched you to ' + moved.join(' + ') + '.';
        }
      }
    }

    say(root, message);
    refresh(root);
  }

  function init(root) {
    if (root.fjOptionsInit) return;
    root.fjOptionsInit = true;
    root.addEventListener('change', onChange, true);
    refresh(root);
  }

  function initAll() {
    document.querySelectorAll('variant-radios.fj-options').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
